const AlignCenter = props => (
  <svg width="20" height="16" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16" {...props}>
    <path
      fill="#fff"
      d="M18.889 2.667H1.11C.497 2.667 0 2.07 0 1.333 0 .597.497 0 1.111 0H18.89C19.503 0 20 .597 20 1.333c0 .737-.497 1.334-1.111 1.334M1.111 9.333H18.89C19.503 9.333 20 8.736 20 8s-.497-1.333-1.111-1.333H1.11C.497 6.667 0 7.264 0 8s.497 1.333 1.111 1.333M14 16H5.111C4.497 16 4 15.403 4 14.667c0-.737.497-1.334 1.111-1.334H14c.614 0 1.111.597 1.111 1.334 0 .736-.497 1.333-1.111 1.333"
    />
  </svg>
);
export default AlignCenter;
